// extracted by mini-css-extract-plugin
export default {"actionWrap":"SapAlert_actionWrap__QkSzQ"};